import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { Timestamp } from '@/utils/date.ts';

export type RecordPriceBody = {
  tileId: string; // only used to update the cash tile or bulk trade
  date: Timestamp; // only used to update the cash tile

  quoteId: string;
  rfsId: string;
  prices: RateWithMarginToRecord[];
};

// send rates with margin to record
// this is the values displayed in the quote tile in big
export type RateWithMarginToRecord = {
  bid: number;
  ask: number;
};

/**
 * Use to record the price of a quote (by clicking on the "timestamp" button).
 */
export const recordPrice = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, RecordPriceBody>({
    query: (body) => ({
      url: '/mifid/recordPrice',
      method: 'POST',
      body,
    }),
  });
};
